import cn from 'classnames';
import { FC } from 'react';
import { useIntl } from 'react-intl';

import { PatientsListColumnName } from '@/shared/config';
import { Button, Checkbox, Popover } from '@/shared/ui';

import {
  i18n,
  PatientListColumnVisibility,
  PatientListToggleableColumn,
} from '../../config';

import styles from './PatientListColumnsMenu.module.scss';

type PatientListColumnsMenuProps = {
  columns: PatientListToggleableColumn[];
  columnVisibility: PatientListColumnVisibility;
  className?: string;
  onToggleColumn: (column: PatientsListColumnName) => void;
  onReset: () => void;
};

export const PatientListColumnsMenu: FC<PatientListColumnsMenuProps> = ({
  columns,
  columnVisibility,
  className,
  onToggleColumn,
  onReset,
}) => {
  const { formatMessage } = useIntl();

  return (
    <Popover
      className={className}
      popoverClassName={styles.popover}
      closeOnMouseLeave={false}
      testID="patient-list-columns-menu"
    >
      <span className={cn(styles.title, 'p3')}>
        {formatMessage({
          id: 'global.columns',
          defaultMessage: 'Columns',
        })}
      </span>

      <Checkbox checked disabled onChange={() => {}} className={styles.option}>
        {formatMessage(i18n.ColumnValues[PatientsListColumnName.PatientName])}
      </Checkbox>

      {columns.map((column) => (
        <Checkbox
          key={column}
          checked={columnVisibility[column] !== false}
          onChange={() => onToggleColumn(column)}
          className={styles.option}
        >
          {formatMessage(i18n.ColumnValues[column])}
        </Checkbox>
      ))}

      <Button
        variant="tertiary"
        size="small"
        className={styles.reset}
        onClick={onReset}
      >
        {formatMessage({ id: 'global.reset', defaultMessage: 'Reset' })}
      </Button>
    </Popover>
  );
};
